import { featuredProducts } from '@/mocks/products';
import ProductCard from '@/components/feature/ProductCard';

export default function FeaturedProducts() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            久久甄选 · 编辑推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            每一件都经过严苛筛选，是我们认为最值得拥有的品质好物
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {featuredProducts.map((product) => (
            <ProductCard key={product.id} product={product} showCategory />
          ))}
        </div>
      </div>
    </section>
  );
}